// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "javascripts/async/" + (chunkId === "ao" ? "web-vitals" : chunkId) + "." + {"7i": "e554d596a6","ao": "9219f9ba8d","c": "708eeaf506","d": "06aafd946a","d9": "949ee6cc7a","k7": "8513eb95f2","l": "598eb12195","y": "6152e3f398","z": "7b408fd47b",}[chunkId] + ".js"
}